module.exports = "/packs/course-small-advertising-operation-fa361a7d5b090cfb771a7d24e574091c.png";